const disableMediaContextMenu = true;

//DK users that landed in SV, then chose to go to DK shop
try {
    if(document.referrer.indexOf("callisto-jewellery.com") !== -1) {
        //Redirect from Swedish webshop, determine if it's a 404
        if(document.title.trim().startsWith("404")){
            window.location.replace("/");
        }
    }
} 
catch (error) {
  console.error("Error:", error.message);
} 
//End DK users that landed in SV, then chose to go to DK shop

function isMobile(){
    return window.matchMedia("(max-width: 959px)").matches;
}

function onProductPage(){   
    return  (document.body.classList.contains("template-product"));
}

document.addEventListener("DOMContentLoaded", (event) => { 

    handleMedia();

});

function handleMedia(){
    const videos = document.querySelectorAll('video');
    const imgs = document.querySelectorAll('img');

    if(disableMediaContextMenu){
        imgs.forEach(img => {
            img.setAttribute('oncontextmenu', "return false;");
        });
    }

    if(onProductPage()){  
        const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                entry.target.onpause = function(){ //after first view it pauses even if visible - so therefor this function
                    if(entry.isIntersecting){ //console.log("Subsequent play")
                        entry.target.play();
                    }
                }
                if (entry.isIntersecting) { //console.log("Play");
                    entry.target.play();
                } else {
                    entry.target.pause(); //console.log("Pause");
                }
            });
        });
        videos.forEach(video => {
            observer.observe(video);
            if(disableMediaContextMenu){
                video.setAttribute('oncontextmenu', "return false;");
            }
        });
    } 
}

/* === PVJ: farvevalg på produktkort === */
(function () {
  var VALGT = 'pvj-variant-valgt';        // låst efter klik
  var VIS   = 'pvj-forhaandsvisning';     // midlertidig ved hover

  function primaertBillede(kort) { return kort.querySelector('.product-item__image--one img'); }

  function skift(kort, url) {
    var img = primaertBillede(kort);
    if (!img || !url) return;
    if (!img.dataset.pvjOprindeligSrc) {
      img.dataset.pvjOprindeligSrc = img.getAttribute('src') || '';
      img.dataset.pvjOprindeligSrcset = img.getAttribute('srcset') || '';
    }
    img.removeAttribute('srcset');
    img.setAttribute('src', url);
  }

  function nulstil(kort) {
    var img = primaertBillede(kort);
    if (!img || !img.dataset.pvjOprindeligSrc) return;
    img.setAttribute('src', img.dataset.pvjOprindeligSrc);
    if (img.dataset.pvjOprindeligSrcset) img.setAttribute('srcset', img.dataset.pvjOprindeligSrcset);
  }

  function felt(e) {
    return e.target && e.target.closest ? e.target.closest('.product-swatches-options__item') : null;
  }

  function markér(kort, sw) {
    kort.querySelectorAll('.product-swatches-options__item').forEach(function (s) {
      s.classList.remove('pvj-valgt'); s.removeAttribute('aria-current');
    });
    sw.classList.add('pvj-valgt');
    sw.setAttribute('aria-current', 'true');
  }

  // Klik: lås kortet til farven.
  document.addEventListener('click', function (e) {
    var sw = felt(e); if (!sw) return;
    var kort = sw.closest('.product-item');
    var url = sw.getAttribute('data-variant-image');
    if (!kort || !url) return;
    e.preventDefault(); e.stopPropagation();
    kort.classList.add(VALGT);
    kort.classList.remove(VIS);
    markér(kort, sw);
    skift(kort, url);
    var link = kort.querySelector('.product-item__image-link');
    var href = sw.getAttribute('href');
    if (link && href) link.setAttribute('href', href);
  }, true);

  // Hover: vis farven med det samme, uden at klikke.
  // VIS-klassen skjuler kortets andet billede, som ellers ville lægge sig ovenpå.
  document.addEventListener('mouseover', function (e) {
    var sw = felt(e); if (!sw) return;
    var kort = sw.closest('.product-item');
    var url = sw.getAttribute('data-variant-image');
    if (!kort || !url) return;
    if (!kort.classList.contains(VALGT)) kort.classList.add(VIS);
    skift(kort, url);
  });

  document.addEventListener('mouseout', function (e) {
    var sw = felt(e); if (!sw) return;
    var kort = sw.closest('.product-item'); if (!kort) return;
    kort.classList.remove(VIS);
    var valgt = kort.querySelector('.product-swatches-options__item.pvj-valgt');
    if (valgt && kort.classList.contains(VALGT)) skift(kort, valgt.getAttribute('data-variant-image'));
    else nulstil(kort);
  });

  // Sølv er udgangspunktet — markér det, så tilstanden er tydelig.
  function sætStandard() {
    document.querySelectorAll('.product-item').forEach(function (kort) {
      if (kort.dataset.pvjStandard) return;
      if (kort.classList.contains(VALGT)) return;
      var felter = kort.querySelectorAll('.product-swatches-options__item');
      for (var i = 0; i < felter.length; i++) {
        if (/silver|sølv/i.test(felter[i].getAttribute('title') || '')) {
          markér(kort, felter[i]); kort.dataset.pvjStandard = '1'; break;
        }
      }
    });
  }

/* === PVJ: metalvisning via ?metal= === */
  // Alle produkter findes i BÅDE sølv og guld, så et almindeligt filter
  // fjerner ingenting. ?metal=guld viser i stedet guldbilledet på hvert kort.
  function anvendMetal() {
    var p = new URLSearchParams(location.search).get('metal');
    if (!p) { sætStandard(); return; }
    var soeg = /guld|gold/i.test(p) ? /gold/i : /silver|sølv/i;
    document.querySelectorAll('.product-item').forEach(function (kort) {
      if (kort.dataset.pvjMetalSat) return;
      var felter = kort.querySelectorAll('.product-swatches-options__item');
      for (var i = 0; i < felter.length; i++) {
        if (soeg.test(felter[i].getAttribute('title') || '')) {
          felter[i].click(); kort.dataset.pvjMetalSat = '1'; break;
        }
      }
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', anvendMetal);
  else anvendMetal();
  new MutationObserver(anvendMetal).observe(document.documentElement, { childList: true, subtree: true });
})();

/* === PVJ: produktside i Dior-stil === */
(function () {
  if (!/\/products\//.test(location.pathname)) return;

  function tekst(el) { return el ? (el.innerText || '').replace(/\s+/g, ' ').trim() : ''; }

  /* --- Prisen ind i købsknappen, til højre --- */
  function prisIKnap() {
    /* Callisto: prisen står under produktnavnet (med før-pris og besparelse) – ikke i knappen */
    document.querySelectorAll('.pvj-btn-pris').forEach(function (el) { el.remove(); });
    document.querySelectorAll('.pvj-knap-med-pris').forEach(function (el) { el.classList.remove('pvj-knap-med-pris'); });
    return;
    var knap = document.querySelector('button[name="add"]');
    var pris = document.querySelector('.product__price');
    if (!knap || !pris) return;
    var t = tekst(pris).replace(/normalpris|udsalgspris|fra/gi, '').trim();
    var beloeb = (t.match(/[\d.,]+\s*(kr|DKK|€)/i) || [t])[0];
    var felt = knap.querySelector('.pvj-btn-pris');
    if (!felt) {
      felt = document.createElement('span');
      felt.className = 'pvj-btn-pris';
      knap.appendChild(felt);
      knap.classList.add('pvj-knap-med-pris');
    }
    felt.textContent = beloeb;
  }

  /* --- Materiale og reference under titlen --- */
  function metaRaekke() {
    /* Callisto: ingen fast materialelinje (smykkerne er i forskellige materialer) */
    return;
    var titel = document.querySelector('.product__title');
    if (!titel || document.querySelector('.pvj-pd-meta')) return;
    var valgt = document.querySelector('[class*="variant-picker"] [aria-checked="true"], .product__color-swatch.selected');
    var farve = valgt ? (valgt.getAttribute('title') || valgt.getAttribute('aria-label') || '').trim() : '';
    var materiale = /gold|guld/i.test(farve) ? 'Guldpläterat 316L stål' : '316L rostfritt stål';

    var sku = '';
    var skuEl = document.querySelector('[class*="sku"]');
    if (skuEl) sku = tekst(skuEl).replace(/^\s*(sku|varenummer)\s*:?\s*/i, '');

    var raekke = document.createElement('div');
    raekke.className = 'pvj-pd-meta';
    raekke.innerHTML = '<span class="pvj-pd-sub">' + materiale + '</span>' +
      (sku ? '<span class="pvj-pd-ref">Reference: ' + sku + '</span>' : '');
    titel.insertAdjacentElement('afterend', raekke);
  }

  /* --- Servicelinje (v2.4): live lagerstatus + levering – står OVER "Læg i kurv" --- */
  var DAGE = ['sön.','mån.','tis.','ons.','tors.','fre.','lör.'];
  var MDR = ['jan.','feb.','mars','apr.','maj','juni','juli','aug.','sep.','okt.','nov.','dec.'];
  function leveringsdato() {
    var d = new Date(), lagt = 0;
    var dage = Number((window.ClauryText || {}).deliveryDays) || 2;
    while (lagt < dage) { d.setDate(d.getDate() + 1); var u = d.getDay(); if (u !== 0 && u !== 6) lagt++; }
    return DAGE[d.getDay()] + ' ' + d.getDate() + ' ' + MDR[d.getMonth()];
  }
  /* Lagerlinjen placeres lige over rækken med kurv-knappen – altså under alt andet (også farvebillederne).
     Bruger den synlige kurv-knap, ikke en skjult formular. */
  function hovedForm() {
    var btns = document.querySelectorAll('[data-section-type="product"] .product-form button[name="add"], .product-form button[name="add"]');
    var atc = null;
    for (var i = 0; i < btns.length; i++) { if (!btns[i].closest('[hidden], .hidden, [data-quick-product], .quick-product-modal')) { atc = btns[i]; break; } }
    var row = atc ? atc.closest('.product-form__controls-group--submit') : null;
    return row || document.querySelector('[data-section-type="product"] .product-form__quantity-and-buy-buttons-wrapper') ||
      document.querySelector('.product-form__quantity-and-buy-buttons-wrapper');
  }
  window.ClauryServiceAnchor = hovedForm;
  function produktData() {
    var el = document.querySelector('[data-section-type="product"] script[id^="ProductJson-"]') || document.querySelector('script[id^="ProductJson-"]');
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }
  function valgtVariant(p) {
    if (!p) return null;
    var input = document.querySelector('[data-section-type="product"] form[action*="/cart/add"] [name="id"]') || document.querySelector('form[action*="/cart/add"] [name="id"]');
    var id = (input && input.value) || new URLSearchParams(location.search).get('variant');
    var v = null;
    (p.variants || []).forEach(function (x) { if (String(x.id) === String(id)) v = x; });
    return v || (p.variants || [])[0] || null;
  }
  function esc(s) { return String(s || '').replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  /* v2.6: én linje – "● På lager · klar til afsendelse | Fri fragt · Levering tor. 8. okt." */
  function servicelinje() {
    var wrap = hovedForm();
    if (!wrap) return;
    var T = window.ClauryText || {};
    var p = produktData(), v = valgtVariant(p);
    var udsolgt = v ? !v.available : /udsolgt|slutsåld|sold out/i.test(tekst(document.querySelector('.inventory-counter__message-text')));
    var andenFarve = udsolgt && p && (p.variants || []).some(function (x) { return x.available && v && x.id !== v.id; });
    var blok = document.querySelector('[class*="inventory-counter"].product__block');
    var row = wrap.previousElementSibling && wrap.previousElementSibling.classList.contains('pvj-service') ? wrap.previousElementSibling : document.querySelector('.pvj-service[data-main]');
    if (!row) {
      row = document.createElement('div');
      row.className = 'pvj-service';
      row.setAttribute('role', 'status');
      row.setAttribute('data-main', '');
    }
    /* Få på lager: bruger graense, tekst og farve fra blokken "Stock level indicator" */
    var lav = null;
    if (!udsolgt && blok && v) {
      try {
        var graense = parseInt(blok.getAttribute('data-low-inventory-threshold'), 10) || 0;
        var js = blok.querySelector('[data-product-inventory-json]');
        var inv = js ? (JSON.parse(js.textContent).inventory || {})[String(v.id)] : null;
        if (inv && inv.inventory_management && inv.inventory_quantity > 0 && graense > 0 && inv.inventory_quantity <= graense) {
          var farve = (blok.style.getPropertyValue('--color-products-stock-medium') || '').trim() || '#E8890C';
          var txt = String(inv.inventory_message || '').replace(/\s+/g, ' ').trim() || ('Endast ' + inv.inventory_quantity + ' kvar');
          lav = { tekst: txt, farve: farve };
        }
      } catch (e) {}
    }
    row.classList.toggle('is-out', !!udsolgt);
    row.classList.toggle('is-low', !!lav);
    var dot = T.liveDot === false ? '' : '<i class="pvj-live" aria-hidden="true"></i>';
    if (udsolgt) {
      row.innerHTML = '<span class="pvj-service__lager"><i class="pvj-dot-out" aria-hidden="true"></i><strong>' + esc(T.out || 'Slutsåld just nu') + '</strong></span>' +
        (andenFarve && T.outOther !== '' ? '<span class="pvj-service__sep" aria-hidden="true"></span><span class="pvj-service__levering">' + esc(T.outOther || 'Finns fortfarande i den andra färgen') + '</span>' : '');
    } else if (lav) {
      row.innerHTML = '<span class="pvj-service__lager"><i class="pvj-dot-low" aria-hidden="true" style="background:' + esc(lav.farve) + '"></i><strong style="color:' + esc(lav.farve) + '">' + esc(lav.tekst) + '</strong>' +
        (T.stockExtra === '' ? '' : '<span class="pvj-service__extra"> · ' + esc(T.stockExtra || 'redo att skickas') + '</span>') + '</span>' +
        (T.delivery === '' ? '' : '<span class="pvj-service__sep" aria-hidden="true"></span><span class="pvj-service__levering">' + esc(T.delivery || 'Fri frakt · Leverans') + ' <b>' + leveringsdato() + '</b></span>');
    } else {
      row.innerHTML = '<span class="pvj-service__lager">' + dot + '<strong>' + esc(T.stock || 'I lager') + '</strong>' +
        (T.stockExtra === '' ? '' : '<span class="pvj-service__extra"> · ' + esc(T.stockExtra || 'redo att skickas') + '</span>') + '</span>' +
        (T.delivery === '' ? '' : '<span class="pvj-service__sep" aria-hidden="true"></span><span class="pvj-service__levering">' + esc(T.delivery || 'Fri frakt · Leverans') + ' <b>' + leveringsdato() + '</b></span>');
    }
    if (wrap.previousElementSibling !== row) wrap.insertAdjacentElement('beforebegin', row);
    if (blok) blok.style.display = 'none';
    tilpasService(row);
  }
  /* Står linjen ikke på én linje, rykker leveringen ned på linje 2 (alle skærmbredder, både på lager og få tilbage) */
  function tilpasService(row) {
    row = row || document.querySelector('.pvj-service[data-main]');
    if (!row) return;
    row.classList.remove('is-stacked');
    var lager = row.querySelector('.pvj-service__lager'), lev = row.querySelector('.pvj-service__levering');
    if (!lager || !lev) return;
    var behov = lager.scrollWidth + lev.scrollWidth + 26;
    if (behov > row.clientWidth) row.classList.add('is-stacked');
  }
  var tilpasTimer;
  window.addEventListener('resize', function () { clearTimeout(tilpasTimer); tilpasTimer = setTimeout(function () { tilpasService(); }, 120); });
  document.addEventListener('change', function (e) {
    if (e.target && e.target.closest && e.target.closest('[data-section-type="product"]')) setTimeout(servicelinje, 120);
  });

  /* --- Foldeafsnit (v2.4): én ren liste, der kan foldes ud – Beskrivelse er åben --- */
  function faner() {
    if (document.querySelector('.cx-acc')) return;
    var beskrivelse = document.querySelector('.product__description');
    var acc = [].slice.call(document.querySelectorAll('.product__block .accordion, [class*="product-block"] .accordion'));
    if (!beskrivelse && !acc.length) return;

    var punkter = [];
    if (beskrivelse) {
      var indhold = beskrivelse.querySelector('[class*="rte"]') || beskrivelse;
      punkter.push({ titel: 'Beskrivning', el: indhold });
    }
    acc.forEach(function (a) {
      var l = a.querySelector('.accordion__label');
      var c = a.querySelector('.accordion__content');
      if (l && c) punkter.push({ titel: tekst(l), el: c });
    });
    if (!punkter.length) return;

    var boks = document.createElement('div');
    boks.className = 'cx-acc';
    punkter.forEach(function (p, n) {
      var d = document.createElement('details');
      d.className = 'cx-acc__item';
      /* Callisto: alle afsnit starter lukket */
      var s = document.createElement('summary');
      s.className = 'cx-acc__head';
      s.innerHTML = '<span></span><i class="cx-acc__icon" aria-hidden="true"></i>';
      s.firstChild.textContent = p.titel;
      var body = document.createElement('div');
      body.className = 'cx-acc__body';
      p.el.style.display = 'block';
      p.el.style.height = 'auto';
      p.el.removeAttribute('hidden');
      body.appendChild(p.el);
      d.appendChild(s); d.appendChild(body);
      boks.appendChild(d);
    });
    (beskrivelse || acc[0]).insertAdjacentElement('beforebegin', boks);
    acc.forEach(function (a) { a.style.display = 'none'; });
    if (beskrivelse) beskrivelse.style.display = 'none';
  }

  function kør() { prisIKnap(); metaRaekke(); servicelinje(); faner(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', kør);
  else kør();

  var prisEl = document.querySelector('.product__price');
  if (prisEl) new MutationObserver(prisIKnap).observe(prisEl, { childList: true, subtree: true, characterData: true });
  document.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('[class*="variant-picker"]')) { setTimeout(prisIKnap, 350); setTimeout(servicelinje, 450); }
  });
})();

/* === PVJ: justeringer runde 17 === */
(function () {

  /* v2.4: servicelinjen skal altid stå lige OVER købsknappen. */
  function flytService() {
    var service = document.querySelector(".pvj-service[data-main]");
    var wrap = (window.ClauryServiceAnchor && window.ClauryServiceAnchor()) || document.querySelector('[data-section-type="product"] .product-form__quantity-and-buy-buttons-wrapper') || document.querySelector(".product-form__quantity-and-buy-buttons-wrapper");
    if (!service || !wrap) return;
    if (wrap.previousElementSibling !== service) wrap.insertAdjacentElement("beforebegin", service);
  }

  function fjernReference() { var r = document.querySelector(".pvj-pd-ref"); if (r) r.remove(); }

  function tommeFooterRaekker() {
    var fo = document.querySelector(".footer");
    if (!fo) return;
    fo.querySelectorAll("[class*='footer__block'], .footer__inner > div").forEach(function (r) {
      var t = (r.innerText || "").replace(/\s+/g, "").trim();
      if (!t && !r.querySelector("img, svg, input, a")) r.style.display = "none";
    });
  }

  function koer() { flytService(); fjernReference(); tommeFooterRaekker(); }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", koer);
  else koer();

  function seEfterExpressKnappen() {
    if (!document.body) return;
    new MutationObserver(function () { flytService(); })
      .observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", seEfterExpressKnappen);
  else seEfterExpressKnappen();
})();

/* === PVJ: materiale ved farvevalg === */
(function () {

  function materiale(navn) {
    /* Callisto: materialet kan ikke gættes ud fra farven */
    return null;
  }

  function navnPaa(sw) {
    return sw.getAttribute("title") || sw.getAttribute("aria-label") || "";
  }

  function linjen(kort, opret) {
    var vaerts = kort.querySelector(".product-swatches-options");
    if (!vaerts) return null;
    var l = vaerts.querySelector(".pvj-materiale");
    if (!l && opret) {
      l = document.createElement("span");
      l.className = "pvj-materiale";
      vaerts.appendChild(l);
    }
    return l;
  }

  function skriv(kort, navn) {
    var tekst = materiale(navn);
    if (!tekst) return;
    var l = linjen(kort, true);
    if (!l) return;
    var ny = '<b>Material:</b> ' + tekst;
    if (l.innerHTML !== ny) l.innerHTML = ny;
  }

  function grundfarve(kort) {
    if (kort.dataset.pvjLaastFarve) return kort.dataset.pvjLaastFarve;
    var sw = kort.querySelectorAll(".product-swatches-options__item");
    if (!sw.length) return null;
    var vid = kort.getAttribute("data-variant-id");
    for (var i = 0; i < sw.length; i++) {
      if (vid && sw[i].getAttribute("data-variant-id") === vid) return navnPaa(sw[i]);
    }
    return navnPaa(sw[0]);
  }

  function nulstil(kort) {
    var n = grundfarve(kort);
    if (n) skriv(kort, n);
  }

  /* Saetter kun linjen paa kort der endnu ikke har en.
     Foer nulstillede den ALLE kort, og da observeren nedenfor koerer
     ved enhver DOM-aendring - ogsaa den billedskiftet ved hover laver -
     sprang teksten tilbage til grundfarven midt i et hover. */
  function saetPaaNyeKort() {
    document.querySelectorAll(".product-item").forEach(function (kort) {
      if (!kort.querySelector(".product-swatches-options__item")) return;
      if (linjen(kort, false)) return;          // har allerede en linje
      nulstil(kort);
    });
  }

  /* Hover styres af hvor musen ER, ikke af mouseout.
     mouseout fyrer ogsaa naar man bevaeger sig mellem elementer inde i
     kortet, og relatedTarget er nogle gange tom - derfor blinkede den. */
  var sidsteKort = null;
  document.addEventListener("mouseover", function (e) {
    var el = e.target;
    if (!el || !el.closest) return;
    var kort = el.closest(".product-item");
    if (sidsteKort && sidsteKort !== kort) { nulstil(sidsteKort); sidsteKort = null; }
    if (!kort) return;
    sidsteKort = kort;
    var sw = el.closest(".product-swatches-options__item");
    if (sw) skriv(kort, navnPaa(sw));
    else nulstil(kort);
  }, true);

  /* Forlader man vinduet helt, kommer der ingen mouseover mere. */
  document.addEventListener("mouseleave", function () {
    if (sidsteKort) { nulstil(sidsteKort); sidsteKort = null; }
  });

  document.addEventListener("click", function (e) {
    var el = e.target;
    var sw = el && el.closest ? el.closest(".product-swatches-options__item") : null;
    if (!sw) return;
    var kort = sw.closest(".product-item");
    if (!kort) return;
    kort.dataset.pvjLaastFarve = navnPaa(sw);
    skriv(kort, navnPaa(sw));
  }, true);

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", saetPaaNyeKort);
  else saetPaaNyeKort();

  function seEfterNyeKort() {
    if (!document.body) return;
    var venter = null;
    new MutationObserver(function () {
      clearTimeout(venter); venter = setTimeout(saetPaaNyeKort, 250);
    }).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", seEfterNyeKort);
  else seEfterNyeKort();
})();

/* === PVJ: materiale paa produktsiden === */
(function () {
  if (!/\/products\//.test(location.pathname)) return;

  function materiale(navn) {
    /* Callisto: materialet kan ikke gættes ud fra farven */
    return null;
  }

  function navnPaa(knap) {
    return knap.getAttribute("data-option-value") || knap.getAttribute("aria-label") || "";
  }

  function boksen() {
    var sw = document.querySelector(".product__color-swatches");
    if (!sw) return null;
    var l = document.querySelector(".pvj-pd-materiale");
    if (!l) {
      l = document.createElement("span");
      l.className = "pvj-pd-materiale";
      sw.appendChild(l);            // inde i boksen, saa den staar paa linje med swatchene
    }
    /* "Farve: Gold"-etiketten over swatchene er overfloedig, naar
       materialet staar ved siden af. Skjules kun for farvevalget,
       ikke for stoerrelse. */
    var boks = sw.closest(".product__option");
    if (boks) {
      var etiket = boks.querySelector(".product__label-wrapper");
      if (etiket) etiket.style.display = "none";
    }
    return l;
  }

  function skriv(navn) {
    var t = materiale(navn);
    if (!t) return;
    var l = boksen();
    if (!l) return;
    var ny = '<b>Material:</b> ' + t;
    if (l.innerHTML !== ny) l.innerHTML = ny;
  }

  /* Den valgte farve: temaet saetter .selected paa knappen. */
  function valgt() {
    var k = document.querySelector(".product__color-swatch.selected");
    if (k) return navnPaa(k);
    var s = document.querySelector("[data-selected-value-for-option]");
    if (s) return (s.textContent || "").trim();
    var f = document.querySelector(".product__color-swatch");
    return f ? navnPaa(f) : null;
  }

  function nulstil() { var n = valgt(); if (n) skriv(n); }

  document.addEventListener("mouseover", function (e) {
    var el = e.target;
    if (!el || !el.closest) return;
    var k = el.closest(".product__color-swatch");
    if (k) { skriv(navnPaa(k)); return; }
    if (el.closest(".product__color-swatches")) return;
    nulstil();
  }, true);

  document.addEventListener("click", function (e) {
    var el = e.target;
    var k = el && el.closest ? el.closest(".product__color-swatch") : null;
    if (k) setTimeout(nulstil, 60);
  }, true);

  function start() {
    nulstil();
    /* Temaet opdaterer sin egen "Farve:"-vaerdi, naar varianten skifter.
       Vi lytter KUN paa det ene felt - ikke paa hele siden - saa et
       hover ikke bliver overskrevet undervejs. */
    var s = document.querySelector("[data-selected-value-for-option]");
    if (s) new MutationObserver(nulstil).observe(s, { childList: true, characterData: true, subtree: true });
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", start);
  else start();
})();

/* === PVJ: ingen browserboble paa farvevaelgere === */
(function () {

  /* Swatchene har title="Silver"/"Gold". Selv naar temaets egen
     tooltip er skjult, viser browseren sin egen boble fra title.
     Vaerdien flyttes til aria-label, saa skaermlaesere stadig kan
     laese farven - og til et datafelt, som vores egen kode bruger. */
  function fjernBobler() {
    document.querySelectorAll(".product-swatches-options__item[title], .product__color-swatch[title]")
      .forEach(function (sw) {
        var navn = sw.getAttribute("title");
        if (!navn) return;
        sw.setAttribute("data-pvj-farve", navn);
        if (!sw.getAttribute("aria-label")) sw.setAttribute("aria-label", navn);
        sw.removeAttribute("title");
      });
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", fjernBobler);
  else fjernBobler();

  /* Nye kort ved filtrering og "hent flere". */
  function seEfterNye() {
    if (!document.body) return;
    var venter = null;
    new MutationObserver(function () {
      clearTimeout(venter); venter = setTimeout(fjernBobler, 250);
    }).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", seEfterNye);
  else seEfterNye();
})();

/* === PVJ: kollektionstekst under produkterne === */
(function () {
  if (!/\/collections\//.test(location.pathname)) return;

  function opsaet() {
    var boks = document.querySelector(".collection-banner__description [data-truncate-wrapper]");
    if (!boks || boks.dataset.pvjKlar) return;

    var indhold = boks.querySelector("[data-truncate-wrapper-content]");
    var gitter = document.querySelector(".collection__products-container") ||
                 document.querySelector(".collection__products");
    if (!indhold || !gitter) return;

    /* Placeres efter HELE sektionen. Saettes den lige efter selve
       produktbeholderen, bliver den optaget som et felt i gitteret
       og lander ved siden af produkterne i stedet for under dem. */
    var efter = gitter.closest(".shopify-section") || gitter;

    /* Hele teksten kopieres ned under produkterne. Den staar skjult,
       indtil man trykker "Vis mere" - saa Google ser den altid, mens
       kunden foerst faar den, naar han beder om det. */
    var nede = document.createElement("div");
    nede.className = "pvj-kol-fuldtekst rte";
    nede.innerHTML = indhold.innerHTML;
    nede.hidden = true;
    efter.insertAdjacentElement("afterend", nede);

    var knap = boks.querySelector(".truncate-wrapper__label--more");
    var klikflade = knap ? (knap.closest("button") || knap.closest("label") || knap) : null;
    if (!klikflade) { boks.dataset.pvjKlar = "1"; return; }

    klikflade.addEventListener("click", function (e) {
      /* Temaets egen udfoldning skal ikke ske - teksten hoerer nedenunder. */
      e.preventDefault();
      e.stopPropagation();
      var aaben = !nede.hidden;
      nede.hidden = aaben;
      boks.setAttribute("data-content-expanded", "false");
      if (!aaben) nede.scrollIntoView({ behavior: "smooth", block: "start" });
    }, true);

    boks.dataset.pvjKlar = "1";
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", opsaet);
  else opsaet();
})();

/* === PVJ: billede i quick-add === */
(function () {

  function skift(media, url, alt) {
    var stor = media.querySelector("[data-pvj-quick-stor]");
    if (!stor || !url) return;
    stor.removeAttribute("srcset");
    stor.src = url;
    if (alt) stor.alt = alt;
    media.querySelectorAll("[data-pvj-quick-thumb]").forEach(function (t) {
      t.classList.toggle("er-valgt", t.getAttribute("data-fuld") === url);
    });
  }

  document.addEventListener("click", function (e) {
    if (!e.target.closest) return;

    var t = e.target.closest("[data-pvj-quick-thumb]");
    if (t) {
      e.preventDefault();
      var m1 = t.closest(".pvj-quick-media");
      if (m1) skift(m1, t.getAttribute("data-fuld"), t.getAttribute("data-alt"));
      return;
    }

    /* Farvevalg - kun inde i popup'en, ikke paa produktsiden */
    var sw = e.target.closest(".product__color-swatch");
    if (!sw) return;
    var pop = sw.closest("[data-quick-product]");
    if (!pop) return;
    var media = pop.querySelector(".pvj-quick-media");
    if (!media) return;
    var farve = sw.getAttribute("data-option-value") || sw.getAttribute("aria-label") || "";
    if (!farve) return;
    setTimeout(function () {
      var el = media.querySelector("[data-pvj-quick-varianter]");
      var liste = [];
      try { liste = JSON.parse(el.textContent) || []; } catch (err) { return; }
      var fundet = liste.filter(function (v) {
        return v.url && (v.titel || "").toLowerCase().indexOf(farve.toLowerCase()) >= 0;
      })[0];
      if (fundet) skift(media, fundet.url, fundet.alt);
    }, 80);
  });
})();

/* === PVJ: popup-detaljer === */
(function () {

  function materiale(navn) {
    /* Callisto: materialet kan ikke gættes ud fra farven */
    return null;
  }
  function farvePaa(sw) {
    return sw.getAttribute("data-option-value") || sw.getAttribute("aria-label") || "";
  }
  function valgtFarve(pop) {
    var v = pop.querySelector(".product__color-swatch.selected");
    if (v) return farvePaa(v);
    var f = pop.querySelector(".product__color-swatch");
    return f ? farvePaa(f) : "";
  }

  /* Materialelinje i stedet for "Farve: Silver" */
  function materialelinje(pop, farve) {
    var boks = pop.querySelector(".product__color-swatches");
    if (!boks) return;
    var l = boks.querySelector(".pvj-quick-materiale");
    if (!l) {
      l = document.createElement("span");
      l.className = "pvj-quick-materiale";
      boks.appendChild(l);
    }
    var t = materiale(farve || valgtFarve(pop));
    if (t) l.innerHTML = '<b>Material:</b> ' + t;
  }

  /* Servicelinje som paa produktsiden */
  function servicelinje(pop) {
    var vaert = pop.querySelector("[data-pvj-quick-footer]");
    if (!vaert || vaert.querySelector(".pvj-service")) return;
    var T = window.ClauryText || {};
    var d = new Date(), lagt = 0, dage = Number(T.deliveryDays) || 2;
    while (lagt < dage) { d.setDate(d.getDate() + 1); var u = d.getDay(); if (u !== 0 && u !== 6) lagt++; }
    var mdr = ["jan.","feb.","mars","apr.","maj","juni","juli","aug.","sep.","okt.","nov.","dec."];
    var ugedage = ["s\u00f6n.","m\u00e5n.","tis.","ons.","tors.","fre.","l\u00f6r."];
    var r = document.createElement("div");
    r.className = "pvj-service";
    r.innerHTML = '<span class="pvj-service__lager">' + (T.liveDot === false ? '' : '<i class="pvj-live" aria-hidden="true"></i>') + '<strong>' + (T.stock || 'I lager') + '</strong>' + (T.stockExtra === '' ? '' : '<span class="pvj-service__extra"> \u00b7 ' + (T.stockExtra || 'klar til afsendelse') + '</span>') + '</span><span class="pvj-service__sep" aria-hidden="true"></span>' +
      (T.delivery === '' ? '' : '<span class="pvj-service__levering">' + (T.delivery || 'Fri frakt \u00b7 Leverans') + ' <b>' + ugedage[d.getDay()] + ' ' + d.getDate() + " " + mdr[d.getMonth()] + '</b></span>');
    vaert.appendChild(r);
  }

  function saetOp(pop) {
    if (pop.dataset.pvjKlar) return;
    /* "Farve:"-etiketten er overfloedig, naar materialet staar der */
    var sw = pop.querySelector(".product__color-swatches");
    if (sw) {
      var boks = sw.closest(".product__option");
      if (boks) {
        var etiket = boks.querySelector(".product__label-wrapper");
        if (etiket) etiket.style.display = "none";
      }
    }
    materialelinje(pop);
    servicelinje(pop);
    pop.dataset.pvjKlar = "1";
  }

  /* Popup'en indsaettes efter klik, saa vi holder oeje med DOM. */
  function kig() {
    document.querySelectorAll("[data-quick-product]").forEach(saetOp);
  }
  function start() {
    if (!document.body) return;
    kig();
    var venter = null;
    new MutationObserver(function () {
      clearTimeout(venter); venter = setTimeout(kig, 120);
    }).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", start);
  else start();

  /* Hover paa guld/soelv skal ogsaa vise det - ikke kun klik. */
  function skiftBillede(pop, farve) {
    var media = pop.querySelector(".pvj-quick-media");
    if (!media) return;
    var el = media.querySelector("[data-pvj-quick-varianter]");
    if (!el) return;
    var liste = [];
    try { liste = JSON.parse(el.textContent) || []; } catch (e) { return; }
    var v = liste.filter(function (x) {
      return x.url && (x.titel || "").toLowerCase().indexOf(farve.toLowerCase()) >= 0;
    })[0];
    if (!v) return;
    var stor = media.querySelector("[data-pvj-quick-stor]");
    if (!stor) return;
    stor.removeAttribute("srcset");
    stor.src = v.url;
    if (v.alt) stor.alt = v.alt;
    media.querySelectorAll("[data-pvj-quick-thumb]").forEach(function (t) {
      t.classList.toggle("er-valgt", t.getAttribute("data-fuld") === v.url);
    });
  }

  document.addEventListener("mouseover", function (e) {
    if (!e.target.closest) return;
    var pop = e.target.closest("[data-quick-product]");
    if (!pop) return;
    var sw = e.target.closest(".product__color-swatch");
    if (sw) {
      var f = farvePaa(sw);
      materialelinje(pop, f);
      skiftBillede(pop, f);
    } else if (!e.target.closest("[data-pvj-quick-thumb]")) {
      materialelinje(pop);
      skiftBillede(pop, valgtFarve(pop));
    }
  }, true);

  document.addEventListener("click", function (e) {
    if (!e.target.closest) return;
    var sw = e.target.closest(".product__color-swatch");
    if (!sw) return;
    var pop = sw.closest("[data-quick-product]");
    if (pop) setTimeout(function () { materialelinje(pop); }, 80);
  }, true);
})();

/* === PVJ: vagt mod fastlaast Klaviyo-popup (23/9-2026) ===
   Fejl: paa mobil rydder Klaviyo ikke altid op, naar pop-up'en lukkes.
   Klassen klaviyo-prevent-body-scrolling bliver paa <body> (siden kan ikke scrolles),
   og det usynlige fuldskaerms-lag (z-index 90000) opfanger alle tryk.
   Vagten fjerner laasen og neutraliserer det efterladte lag, naar pop-up'en er lukket,
   og saetter laget tilbage, hvis Klaviyo aabner pop-up'en igen (fx via "10% Rabat"-fanen).
   Roerer ikke pop-up'ens indhold og ikke selve fanen (den er lille, ikke fuldskaerm). */
(function () {
  var LAAS = "klaviyo-prevent-body-scrolling";
  var sekLaast = 0;
  var gendanTid = 0;

  function erFuldskaermslag(el) {
    if (!el || !el.getBoundingClientRect) return false;
    var s = window.getComputedStyle(el);
    if (s.position !== "fixed") return false;
    var r = el.getBoundingClientRect();
    return r.width >= window.innerWidth * 0.9 && r.height >= window.innerHeight * 0.9;
  }

  function ryd() {
    if (!document.body) return;
    if (Date.now() - gendanTid < 5000) return;   // pop-up'en er lige aabnet igen - lad den vaere
    document.body.classList.remove(LAAS);
    var lag = document.querySelectorAll('div[class*="kl-private-reset-css"]');
    for (var i = 0; i < lag.length; i++) {
      if (!erFuldskaermslag(lag[i])) continue;
      lag[i].style.display = "none";
      lag[i].style.pointerEvents = "none";
      lag[i].setAttribute("data-pvj-ryddet", "1");
    }
  }

  function gendan() {
    var lag = document.querySelectorAll('[data-pvj-ryddet]');
    if (!lag.length) return;
    gendanTid = Date.now();
    for (var i = 0; i < lag.length; i++) {
      lag[i].style.display = "";
      lag[i].style.pointerEvents = "";
      lag[i].removeAttribute("data-pvj-ryddet");
    }
  }

  function rydSenere() {
    setTimeout(ryd, 600);
    setTimeout(ryd, 1500);
    setTimeout(ryd, 3000);
  }

  function start() {
    document.addEventListener("click", function (e) {
      var t = e.target;
      if (!t || !t.closest) return;
      if (t.closest("button.klaviyo-close-form")) rydSenere();          // krydset
      else if (erFuldskaermslag(t)) rydSenere();                        // tryk paa den moerke baggrund
      else if (t.closest('[class*="kl-private"]')) gendan();            // fx "10% Rabat"-fanen
    }, true);

    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape") rydSenere();
    }, true);

    // Naar Klaviyo aabner en pop-up, saetter den laasen paa igen - saa skal laget tilbage.
    if (window.MutationObserver) {
      new MutationObserver(function () {
        if (document.body.classList.contains(LAAS)) gendan();
      }).observe(document.body, { attributes: true, attributeFilter: ["class"] });
    }

    // Sikkerhedsnet: en pop-up maa aldrig holde siden laast i mere end 45 sekunder.
    setInterval(function () {
      if (!document.body.classList.contains(LAAS)) { sekLaast = 0; return; }
      sekLaast += 5;
      if (sekLaast >= 45) { gendanTid = 0; ryd(); }
    }, 5000);
  }

  if (document.body) start();
  else document.addEventListener("DOMContentLoaded", start);
})();

/* === PVJ: udvidet maaling (23/9-2026) ===
   1) Cookiefri Umami-haendelser paa det, Shopify-pixlen ikke kan se:
      info-faneblade, stoerrelsesguide, klik paa "Laeg i kurv" og nyhedsbrevstilmelding.
   2) Klaviyo "Added to Cart" sendes fra hjemmesiden for de besoegende, Klaviyo kender.
      (Anonyme besoegende kan Klaviyo ikke gemme haendelser paa - deres tal staar i Umami/Meta.) */
(function () {
  function um(navn, data) {
    try { if (window.umami && window.umami.track) window.umami.track(navn, data); } catch (e) {}
  }

  /* ---------- Umami: cookiefri haendelser ---------- */
  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;

    var fane = e.target.closest('.cx-acc__head, .pvj-fane, .accordion__label');
    if (fane) { um('info_faneblad', { emne: (fane.textContent || '').trim().slice(0, 40), side: location.pathname }); return; }

    if (e.target.closest('a[href*="size-guide"]')) { um('stoerrelsesguide', { side: location.pathname }); return; }

    if (e.target.closest('[name="add"], .product-form__cart-submit')) {
      um('klik_laeg_i_kurv', { side: location.pathname });
      setTimeout(klaviyoKurv, 900);
      setTimeout(klaviyoKurv, 2500);
    }
  }, true);

  window.addEventListener('klaviyoForms', function (e) {
    var d = e.detail || {};
    if (d.type === 'submit') um('nyhedsbrev_tilmeldt', { formular: d.formId || '', side: location.pathname });
    if (d.type === 'open') um('popup_vist', { formular: d.formId || '' });
  });

  /* ---------- Klaviyo: Added to Cart ---------- */
  var sidsteKurv = null;
  function hentKurv() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.json(); }).catch(function () { return null; });
  }
  hentKurv().then(function (k) { sidsteKurv = k; });

  function nyVare(gammel, ny) {
    if (!ny) return null;
    var foer = {};
    ((gammel && gammel.items) || []).forEach(function (i) { foer[i.key] = i.quantity; });
    var fund = null;
    (ny.items || []).forEach(function (i) {
      var a = foer[i.key] || 0;
      if (!fund && i.quantity > a) fund = { vare: i, antal: i.quantity - a };
    });
    return fund;
  }

  function klaviyoKurv() {
    hentKurv().then(function (kurv) {
      var d = nyVare(sidsteKurv, kurv);
      sidsteKurv = kurv;
      if (!d || !window.klaviyo || !window.klaviyo.push) return;
      var varer = (kurv && kurv.items) || [];
      window.klaviyo.push(['track', 'Added to Cart', {
        $value: (kurv.total_price || 0) / 100,
        AddedItemProductName: d.vare.product_title,
        AddedItemProductID: d.vare.product_id,
        AddedItemVariantID: d.vare.variant_id,
        AddedItemSKU: d.vare.sku,
        AddedItemImageURL: d.vare.image,
        AddedItemURL: location.origin + (d.vare.url || ''),
        AddedItemPrice: (d.vare.price || 0) / 100,
        AddedItemQuantity: d.antal,
        ItemNames: varer.map(function (v) { return v.product_title; }),
        CheckoutURL: location.origin + '/checkout',
        Items: varer.map(function (v) {
          return {
            ProductID: v.product_id, SKU: v.sku, ProductName: v.product_title,
            Quantity: v.quantity, ItemPrice: (v.price || 0) / 100,
            RowTotal: (v.line_price || 0) / 100,
            ProductURL: location.origin + (v.url || ''), ImageURL: v.image
          };
        })
      }]);
    });
  }
})();

/* === PVJ: guldvisning paa guld-kollektionen (24/9-2026) ===
   Produktkort viser normalt soelv, fordi det er produktets hovedbillede.
   Paa kollektioner med "guld" i adressen vaelges guld-varianten automatisk,
   saa kortene viser guld - og linket peger paa guld-varianten. */
(function () {
  if (!/\/collections\/[^/?#]*guld/i.test(location.pathname)) return;

  function saetGuld(kort) {
    if (kort.dataset.pvjGuld) return;
    var felter = kort.querySelectorAll('.product-swatches-options__item');
    var guld = null;
    for (var i = 0; i < felter.length; i++) {
      if (/gold|guld/i.test(felter[i].getAttribute('title') || '')) { guld = felter[i]; break; }
    }
    if (!guld) return;
    var url = guld.getAttribute('data-variant-image');
    var img = kort.querySelector('.product-item__image--one img');
    if (img && url) {
      if (!img.dataset.pvjOprindeligSrc) {
        img.dataset.pvjOprindeligSrc = img.getAttribute('src') || '';
        img.dataset.pvjOprindeligSrcset = img.getAttribute('srcset') || '';
      }
      img.removeAttribute('srcset');
      img.setAttribute('src', url);
    }
    felter.forEach(function (s) { s.classList.remove('pvj-valgt'); s.removeAttribute('aria-current'); });
    guld.classList.add('pvj-valgt');
    guld.setAttribute('aria-current', 'true');
    var link = kort.querySelector('.product-item__image-link');
    var href = guld.getAttribute('href');
    if (link && href) link.setAttribute('href', href);
    kort.classList.add('pvj-variant-valgt');
    kort.dataset.pvjStandard = '1';   // saa soelv-standarden ikke overskriver
    kort.dataset.pvjGuld = '1';
  }

  function koer() { document.querySelectorAll('.product-item').forEach(saetGuld); }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', koer);
  else koer();
  if (window.MutationObserver) new MutationObserver(koer).observe(document.documentElement, { childList: true, subtree: true });
  var n = 0;
  var t = setInterval(function () { koer(); if (++n > 20) clearInterval(t); }, 500);
})();
/* (Claurys Klaviyo-popup-styring er fjernet i Callisto-versionen) */
